<template>
  <v-app id="app">
    <v-main>
      <WarningDialog :isDialogOpened="true" />
      <router-view />
    </v-main>
  </v-app>
</template>

<script>
import { defineComponent } from "@vue/composition-api"
import WarningDialog from "./components/WarningDialog"
export default defineComponent({
  name: "App",
  head: {
    link() {
      return [
        {
          href: "https://cdn.jsdelivr.net/npm/@mdi/font@5.x/css/materialdesignicons.min.css"
        },
        { href: "https://fonts.googleapis.com/css?family=Material+Icons" }
      ]
    }
  },
  setup() {
    const isDialogOpened = ref(false)
    return { isDialogOpened }
  },
  components: { WarningDialog }
})
</script>

<style lang="scss">
@import url("https://fonts.googleapis.com/css?family=Noto+Serif+JP");

* :not(.v-icon) {
  font-family: "Noto Serif JP" !important;
}
</style>
